<script>
  import { mapState } from 'vuex'
  import calculate from '@mixins/calculate'
  import VCheckbox from '@components/Checkbox'

  export default {
    name: 'Group',
    components: { VCheckbox },
    mixins: [calculate],
    template: '#template_modulkonfigurator_group',
    props: {
      areaKey: {
        type: String,
        required: true
      },
      headline: {
        type: Boolean,
        default: false,
        required: false
      },
      parentMaxReached: {
        type: Boolean,
        default: false,
        required: false
      },
      maxReachedTrigger: {
        type: Boolean,
        required: false,
      }
    },
    data () {
      return {
        uid: null,
        isActive: true,
        isOpen: false,
        select: {
          value: false
        }
      }
    },
    methods: {
        changeSelection(selectId, e) {
            const self = this

// console.log('e')
// console.dir(typeof this.getAreaByKey(e.target.value))
// console.dir(typeof this.getAreaByKey(e.target.value).name)
// console.dir(e.target.value)
//             if (typeof self.$parent === "undefined") {
//
// console.dir('self.$parent')
// console.dir(self.$parent)
//             }

            if (typeof self.$parent.currentSelects === "undefined") {
              self.$parent.currentSelects = []
// console.log('self.$parent.currentSelects')
// console.dir(self.$parent.currentSelects)
            }
            //   self.$parent.currentSelects = null
              if (typeof self.$parent.currentSelects.current === "undefined") {
                  this.$parent.currentSelects.current = []
              }
              if (typeof self.$parent.currentSelects.selected === "undefined") {
                  this.$parent.currentSelects.selected = []
              }
            // }
            let current = self.$parent.currentSelects.current
            let selected = self.$parent.currentSelects.selected

          let selectionName = ''
          if (this.getAreaByKey(e.target.value) && this.getAreaByKey(e.target.value).name) {
            selectionName = this.getAreaByKey(e.target.value).name
          }

            let indexSelected = -1
            let indexPrevious = -1
            let selectPrevious = ""
            // selectionName = selectionName.split(" ").join("_")
            // selectPrevious = selectPrevious.split(" ").join("_")

            if (typeof current[selectId] !== "undefined") {
                selectPrevious = current[selectId]
            }

            if (selected.length > 0) {
                indexSelected = selected.indexOf(selectionName);

                if(indexSelected > -1
                    && this.getAreaByKey(e.target.value)
                    && this.getAreaByKey(e.target.value).name
                ) {
                    alert('Bereits ausgewählt: ' + self.getAreaByKey(e.target.value).name);
                    this.select.value = false
                }
            }

            if (selectPrevious !== ""){
                indexPrevious = selected.indexOf(selectPrevious)
                if(indexPrevious > -1){
                    selected.splice(indexPrevious, 1)
                }
            }

            selected.push(selectionName);
            current[selectId] = selectionName
        },
        toggleList (labelId) { //@todo refactor
            var visiblity =  document.getElementById(labelId).style.display;

            if (visiblity == "" || visiblity == "block") {
                visiblity =  document.getElementById(labelId).style.display = "none"
            } else {
                visiblity =  document.getElementById(labelId).style.display = "block"
            }

            // this.open = !this.open
            this.isOpen = !this.isOpen
        },
        toggleClass: function(){
            this.isActive = !this.isActive;
        },
      isDisabled (moduleKey) {
        const self = this
        let module = self.form.allModules.find((m) => {
          return m.id === moduleKey
        })
        let validators = self.group.validators.map((validator) => {
          return validator.key
        })
        if (this.group.valid && validators.indexOf('min') === -1) {
          return false
        }
        else if (this.group.valid && (module && module.selected === false)) {
          return true
        }
        return false
      },
      getAreaByKey (key) {
        const self = this
        let area = self.form.allAreas.find((area) => {
          return area.id === key
        })
        return area
      },
      maxReached () {
        const self = this
        const group = self.group
        if (self.parentMaxReached) {
          return true
        }
        let maxValidator = group.validators.find((item) => {
          return item.key === 'max'
        })

        if (!maxValidator) {
          return false
        }

        if (maxValidator.value === group.selectedModules) {
          return true
        }

        return false
      },
      isSelected (moduleKey) {
        const self = this
        let module = self.form.allModules.find((m) => {
          return m.id === moduleKey
        })

        return (module && module.selected)
      }
    },
    computed: {
      ...mapState(['form']),
      group () {
        const self = this
        let group = self.form.allAreas.find((group) => {
          return group.id === self.areaKey
        })

        return group
      },
        groupCssClass () {
            let result = []
            if (!this.group.valid) {
                result.push('bg-danger')
            }
            result.push('modulkonfigurator__group--selected-' + this.group.selectedModules)

            return result
        },
      parentMaxReachedAndNoModuleSelected () {
        return this.parentMaxReached && (this.group.selectedModules == 0)
      },
    },
    mounted () {
      this.uid = this._uid
    },
    watch: {
        // 'select.value' (newVal) {
      'select.value' () {
        const self = this
        const form = Object.assign({}, self.form)

        self.group.submodules.forEach((item) => {
          let moduleIndex = form.allModules.findIndex((module) => {
            return module.id === item
          })

          if (moduleIndex > -1) {
            form.allModules[moduleIndex].selected = false
          }
        })
        self.calculateForm(form).then((form) => {
          self.$store.dispatch('setForm', form)
        })
      }
    }
  }
</script>
